import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MessageRounded } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { paths } from '../../consts';
import { colors } from '../../assets/constStyles';
import { useResizeWidthWindow } from '../hook/useResizeWidthWindow';

const AssistantButton = styled(motion(Link))`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background-color: ${colors.colorRed};
  border-color: ${colors.colorRed};
  color: white;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: ${colors.colorMutedYellow};
    border-color: ${colors.colorMutedYellow};
    transform: translateY(-2px);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ChatButton: React.FC = () => (
    <div style={{ position: 'absolute', bottom: useResizeWidthWindow() > 500 ? 110 : 70, right: 40 }}>
        <AssistantButton
            to={paths.CHAT}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 10 }}
            animate={{
              opacity: 1,
              y: [0, -5, 0],
              transition: {
                duration: 1.5,
                repeat: Infinity,
                repeatType: 'mirror',
                ease: [0, 0.71, 0.2, 1.01],
              },
            }}
        >
            <MessageRounded/>
        </AssistantButton>
    </div>
);
